import React, { useState, useRef } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames/bind'

import Card from './Card'
import { Headline1 } from 'components/ui/Typography'
import ViewportEnter from 'components/motion/ViewportEnter'

import s from './Cards.module.scss'
import HorizontalWapper from '../HorizontalWrapper'
const cn = classNames.bind(s)

const _ = {
  maxLength: 4,
}

const Cards = ({ data }) => {
  const { primary, fields } = data
  const [maxIndex, setMaxIndex] = useState(_.maxLength)
  const [showCards, setShowCards] = useState(false)
  const constraintRef = useRef(null)

  return (
    <HorizontalWapper>
      <ViewportEnter onEnter={() => setShowCards(true)} onExit={() => setShowCards(false)} threshold={0} once={false}>
        <div className={cn('inner', { showCards })} ref={constraintRef}>
          <div className={cn('title')}>
            <Headline1 as="h3">{primary.section_title[0].text}</Headline1>
          </div>
          <ul className={cn('cards')}>
            {fields.slice(0, _.maxLength).map((field, i) => (
              <Card
                key={i}
                card={field.card}
                index={i}
                total={fields.slice(0, _.maxLength).length}
                maxIndex={maxIndex}
                constraintRef={constraintRef}
                show={showCards}
                onCardDragged={setMaxIndex}
              />
            ))}
          </ul>
        </div>
      </ViewportEnter>
    </HorizontalWapper>
  )
}

Cards.propTypes = {
  data: PropTypes.object,
}

export default Cards
